import { ISectorsInitialState } from '@types';
import { createSelector } from 'reselect';
import { RootState } from 'store';

const sectorsSelector = (state: RootState) => state.sectors;

const sectorsListSelector = createSelector([sectorsSelector], (sectors: ISectorsInitialState) => sectors.sectorsList);

const sectorSelector = createSelector([sectorsSelector], (sectors: ISectorsInitialState) => sectors.sector);

export const sectorsSel = {
    sectorsSelector,
    sectorSelector,
    sectorsListSelector,
};
